import { useLocation, useNavigate } from "react-router-dom";
import { Onboarding } from "sdk/onboardings";
import { nextFactory, previousFactory } from "~/OnboardingApp/events";
import { useMetaByPathConfig } from "./hooks";
import { useRouteMeta } from "./hooks/useRouteMeta";
import { handleNavigate } from "./utils/handleNavigate";
const { VITE_ENVIRONMENT } = import.meta.env;
interface UseNav {
  goToNext: (onboarding?: Partial<Onboarding>) => void;
  goToPrevious: () => void;
  phase: string;
  stepPercent: number;
}

export const useNav = (): UseNav => {
  const location = useLocation();
  const navigate = useNavigate();
  const { nextStepData, previousStepData, recalculateNextStep } =
    useRouteMeta();
  const { metaByPath, questionnaireOrder, progressBarTotal } =
    useMetaByPathConfig();

  const analyticsStem = metaByPath[location.pathname]?.analyticsStem;

  const currentPage = location.pathname;
  const stepIndex = questionnaireOrder.findIndex(
    (step) => step === currentPage,
  );

  if (VITE_ENVIRONMENT === "development" && stepIndex === -1) {
    throw new Error(`Path ${currentPage} not found in journey`);
  }

  const stepPercent = (stepIndex / (progressBarTotal - 1)) * 100;

  return {
    goToNext: (onboarding) =>
      handleNavigate({
        stepData: onboarding ? recalculateNextStep(onboarding) : nextStepData,
        navigate,
        state: location.state,
        tracker: nextFactory(analyticsStem),
      }),
    goToPrevious: () =>
      handleNavigate({
        stepData: previousStepData,
        navigate,
        isPrevious: true,
        state: location.state,
        tracker: previousFactory(analyticsStem),
      }),
    phase: metaByPath[currentPage].phase,
    stepPercent,
  };
};
